/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Add new layer to the map
* User can select which bands to visualize as RGB
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { ImageService } from '@/services/image.service';
// import { getAllowedOutputs } from '../block_compatibility_checks';

// let dropdown = [
//     ["Difference Threshold", "classification"],
//     // ["Differencing", "differencing"],
// ];

let imageChoice = [
    ["None", "none"]
]


Blockly.Blocks['analyse_change_detection'] = {
    init: function () {

        // check if is in flyout - i.e. in the toolbox
        // CAUTION: init function is called everytime a block moves as Blockly creates a hidden copy of the block
        // during the move which is then immediately deleted - without sending a delete event - so this will
        // mean that multiple blocks get registered to the image listener however, the image listener
        // will delete blocks during a publish event from it's registry if the block is no longer on the workspace
        if(!this.isInFlyout) {
            ImageService.registerImageListener(this.id, this.onImageServiceChange)
        }

        this.images = ImageService.getImages();

        // temporarily removed until we confirm whether or not we want ratio method
        // this.appendDummyInput()
        //     .appendField("Change detection method: ")
        //     .appendField(new Blockly.FieldDropdown(dropdown, this.validateChangeDetectionMethod), "changeDetection")

        this.appendDummyInput()
            .appendField("Change Detection")
            
        this.appendDummyInput("thresholdCheck")
            .appendField("Apply custom threshold ")
            .appendField(new Blockly.FieldCheckbox(false, this.validateThresholdCheck), 'thresholdCheck')
        
        this.appendDummyInput("lineBreak")

        this.appendDummyInput("image1")
            .appendField("Image 1: ")
            .appendField(new Blockly.FieldDropdown(this.generateImageDropdown(this.images), this.validateImage1), "image1Choice")

        this.appendDummyInput("image2")
            .appendField("Image 2: ")
            .appendField(new Blockly.FieldDropdown(this.generateImageDropdown(this.images), this.validateImage2), "image2Choice")

        this.appendStatementInput("do");

        this.setStyle('changeDetection');
        this.satelliteParameter = 'analyse_change_detection'
    },

    generateImageDropdown: function(images) {
        let imagesArray = images;
        let imageValues = [];

        if (images.length > 0) {
            imagesArray.forEach((image) => {
                imageValues.push([image.userSelectedName, image.imageValue])
            });
        } else {
            imageValues = imageChoice
        }

        return imageValues
    },

    generateImageValues: function(images) {
        let valuesArray = []
        if (images && images.length > 0) {
            images.forEach((image) => {
                valuesArray.push(image.imageValue)
            })
        } else {
            valuesArray = ['none']
        }
        return valuesArray
    },

    validateChangeDetectionMethod: function(newValue) {
        let sourceBlock = this.getSourceBlock();

        if (newValue === 'differencing' && sourceBlock.getField("thresholdCheck")) {
            sourceBlock.removeInput("thresholdCheck");
            sourceBlock.removeThresholdFields(sourceBlock);
        } else if (newValue === 'classification' && !sourceBlock.getField("thresholdCheck")) {
            sourceBlock.appendDummyInput("thresholdCheck")
                .appendField("Apply custom threshold ")
                .appendField(new Blockly.FieldCheckbox(false, sourceBlock.validateThresholdCheck), 'thresholdCheck')
            sourceBlock.moveInputBefore("thresholdCheck", "lineBreak");
        }
    },

    validateImage1: function(newValue) {
        let sourceBlock = this.getSourceBlock();
        let image2Value = sourceBlock.getFieldValue("image2Choice")
        if (newValue === image2Value) {
            sourceBlock.setWarningText("The change detection image options are the same. Please select different options from the dropdown", "changeDetection_sameImageWarning")
        } else {
            sourceBlock.setWarningText(null, "changeDetection_sameImageWarning")
        }
        sourceBlock.validateImageAreas(newValue, image2Value);

        return newValue;
    },

    validateImage2: function(newValue) {
        let sourceBlock = this.getSourceBlock();
        let image1Value = sourceBlock.getFieldValue("image1Choice")
        if (newValue === image1Value) {
            sourceBlock.setWarningText("The change detection image options are the same. Please select different options from the dropdown", "changeDetection_sameImageWarning")
        } else {
            sourceBlock.setWarningText(null, "changeDetection_sameImageWarning")
        }
        sourceBlock.validateImageAreas(image1Value, newValue);
        return newValue;
    },

    validateImageAreas(image1Value, image2Value) {
        let index1 = this.images.findIndex(image => image.imageValue === image1Value);
        let index2 = this.images.findIndex(image => image.imageValue === image2Value);

        if(index1 === -1 || index2 === -1) {
            this.setWarningText("Please select two images", 'image_warning');
            return;
        } else {
            this.setWarningText(null, 'image_warning');
        }

        let area1Name = this.images[index1].areaName;
        let area2Name = this.images[index2].areaName;

        if(area1Name !== area2Name) {
            this.setWarningText("Images selected do not have the same areas", 'area_warning')
        } else if(area1Name === 'NA' || area2Name === 'NA') {
            this.setWarningText("Images do not have an assigned area", 'area_warning')
        } else {
            this.setWarningText(null, 'area_warning')
        }
    },

    validateThresholdCheck: function(newValue) {
        let sourceBlock = this.getSourceBlock();
        sourceBlock.showThreshold_ = newValue == 'TRUE';
        sourceBlock.updateThresholdFields(sourceBlock);
        return newValue;
    },

    updateThresholdFields: function(block) {
        if (block.showThreshold_) {
            block.addThresholdFields(block);
        } else {
            if(this.getInput("thresholdInput")) {
                block.removeThresholdFields(block, true);
            }
        }
    },

    addThresholdFields: function(block) {
        block.appendDummyInput("thresholdInput")
            .appendField("Threshold: ", 'thresholdText')
            .appendField(new Blockly.FieldDropdown(
                [[">", "gt"],
                ["<", "lt"],
                ["≤", "lte"],
                ["≥", "gte"]]
            ), "thresholdComparisontype")
            .appendField(new Blockly.FieldNumber(5, -100, 100), "thresholdValue")
            .appendField(new Blockly.FieldDropdown([["%", "%"], ['units', 'units']]), 'thresholdUnit')
        block.moveInputBefore("thresholdInput", "lineBreak")
    },

    removeThresholdFields: function(block) {
        block.removeInput("thresholdInput")
    },

    onImageServiceChange(images, block) {
        this.images = images;

        let imageValues = block.generateImageDropdown(images)
        let valuesArray = block.generateImageValues(images)
        
        block.updateImageDropdowns(imageValues, valuesArray)
    },

    updateImageDropdowns: function(imageDropdown, valuesArray) {
        let image1Val = this.getFieldValue("image1Choice")
        let image2Val = this.getFieldValue("image2Choice")

        this.removeInput("image1")
        this.removeInput("image2")

        this.appendDummyInput("image1")
            .appendField("Image 1: ")
            .appendField(new Blockly.FieldDropdown(imageDropdown, this.validateImage1), "image1Choice")

        this.appendDummyInput("image2")
            .appendField("Image 2: ")
            .appendField(new Blockly.FieldDropdown(imageDropdown, this.validateImage2), "image2Choice")
        
        this.moveInputBefore("image1", "do");
        this.moveInputBefore("image2", "do");

        if (valuesArray) {
            // reenter image values
            if(valuesArray.includes(image1Val)) {
                this.setFieldValue(image1Val, 'image1Choice')
            }

            if(valuesArray.includes(image2Val)) {
                this.setFieldValue(image2Val, 'image2Choice')
            }
        }
        
    },
};